import { render, staticRenderFns } from "./admin-authorize.vue?vue&type=template&id=deb397e8&scoped=true&"
import script from "./admin-authorize.vue?vue&type=script&lang=js&"
export * from "./admin-authorize.vue?vue&type=script&lang=js&"
import style0 from "./admin-authorize.vue?vue&type=style&index=0&id=deb397e8&prod&lang=css&"
import style1 from "./admin-authorize.vue?vue&type=style&index=1&id=deb397e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb397e8",
  null
  
)

export default component.exports